import { BackgroundColors } from '../../../types/BackgroundColor'

export interface RichTextPDComponentValueTypes {
  value: string
}

export interface RichTextPDComponentTypes {
  richText: RichTextPDComponentValueTypes
  textColor?: keyof typeof RichTextTextColors
  bgColor?: keyof typeof BackgroundColors
  hasCustomStyle?: boolean
  inheritFont?: boolean
}

type RichTextComponentTypes = {
  className?: string
  key?: string
  data: RichTextPDComponentTypes
  regions: any[]
}

export enum RichTextTextColors {
  'black' = 'text-black',
  'white' = 'text-white'
}

export default RichTextComponentTypes
